<div>
	<div class="py-2 px-0 mt-2">
		<ul class="col-sm-12 px-0 py-2 list-group mt-2">
			<li class="list-group-item border-0 rounded-0 px-0 py-3 list-item-bg list-cursor"
				[ngClass]="{'sidebar-item-active-dark': selectedMenuItem == 'documentstore', 'custom-list-item-dark': selectedMenuItem != 'documentstore'}"
				(click)="sideItemClick('documentstore')">
				<h6 class="flaot-left ml-2 mb-0 sidebar-list-text">
					<i class="far fa-list-alt mx-2" aria-hidden="true"></i>
					{{ 'DOCUMENT_STORE.DS_SIDEBAR_DOCUMENT_STORE' | translate }}
				</h6>
			</li>
			<ul class="col-sm-12 px-0 py-0 list-group rounded-0">
				<li class="list-group-item border-0 rounded-0 px-0 py-2 list-item-bg list-cursor" *ngIf="addDocumentToStore"
					(click)="sideItemClick('adddocument')"
					[ngClass]="{'sidebar-item-active-dark': selectedMenuItem == 'adddocument', 'custom-list-item-dark': selectedMenuItem != 'adddocument'}">
					<h6 class="flaot-left mb-0 ml-4">
						<i class="far fa-plus-square mx-2" aria-hidden="true"></i>
						{{ 'DOCUMENT_STORE.DS_SIDEBAR_ADD_DOCUMENT' | translate }}
					</h6>
				</li>
			</ul>
			<li class="list-group-item border-0 rounded-0 px-0 py-3 list-item-bg list-cursor"
				[ngClass]="{'sidebar-item-active-dark': selectedMenuItem == 'deleteddocument', 'custom-list-item-dark': selectedMenuItem != 'deleteddocument'}"
				(click)="sideItemClick('deleteddocument')">
				<h6 class="flaot-left ml-2 mb-0 sidebar-list-text">
					<i class="far fa-dumpster mx-2" aria-hidden="true"></i>
					{{ 'DOCUMENT_STORE.DS_SIDEBAR_DELETED_DOCUMENT' | translate }}
				</h6>
			</li>
			<li class="list-group-item border-0 rounded-0 px-0 py-3 list-item-bg list-cursor" *ngIf="viewProcedureInstanceOutputList"
				[ngClass]="{'sidebar-item-active-dark': selectedMenuItem == 'procedureInstance', 'custom-list-item-dark': selectedMenuItem != 'procedureInstance'}"
				(click)="sideItemClick('procedureInstance')">
				<h6 class="flaot-left ml-2 mb-0 sidebar-list-text">
					<i class="far fa-clipboard-list mx-2" aria-hidden="true"></i>
					{{ 'DOCUMENT_STORE.DS_SIDEBAR_PROCEDURE_INSTANCES' | translate }}
				</h6>
			</li>
		</ul>
	</div>
</div>